// import {h} from 'preact';
import React from 'react';
import styles from './styles.css';
import {observer, inject} from 'mobx-react';

import {AppBar as RTAppBar} from 'react-toolbox/lib/app_bar';
import {IconMenu, MenuItem, MenuDivider} from 'react-toolbox/lib/menu';

function AppBar({view, title, toggleSidebar}) {

  const renderLogin = () => {
    if (view.isLoggedIn) {
      return (
        <div>
          {view.currentUser.get('displayName')}
        </div>
      )
    } else {
      return (
        <div>
          <a onClick={() => view.signIn()}>login</a>
        </div>
      )
    }
  };

  const renderRightIcon = () => (
    <IconMenu icon='more_vert' position='topLeft' menuRipple>
      <MenuItem value='download' icon='get_app' caption='Download' />
      <MenuItem value='help' icon='favorite' caption='Favorite' />
      <MenuItem value='settings' icon='open_in_browser' caption='Open in app' />
      <MenuDivider />
      <MenuItem value='signout' icon='delete' caption='Delete' disabled />
    </IconMenu>
  );

  const handleRightIconClick = () => {
    view.signOut();
  };

  return (
    <RTAppBar
      theme={styles}
      flat
      title={title}
      leftIcon="menu"
      rightIcon={view.isLoggedIn ? "more_vert" : null}
      onLeftIconClick={toggleSidebar}
      onRightIconClick={handleRightIconClick}
    >
      { renderLogin() }
    </RTAppBar>
  )
}

export default inject('view')(observer(AppBar));



// WEBPACK FOOTER //
// ./src/components/AppBar/AppBar.js